export enum FileUploadState {
  LOADING,
  SUCCESS,
  ERROR
}
